import { Badge } from '@/components/badge/badge';
import {
  DELIVERY_STATUS_LABELS,
  getLabel,
} from '../../constants/notification-delivery-labels.constant';

function statusBadgeVariant(status: string) {
  if (status === 'sent') return 'success' as const;
  if (status === 'pending') return 'warning' as const;
  if (status === 'failed') return 'destructive' as const;
  return 'neutral' as const;
}

interface DeliveryStatusBadgeProps {
  /** A DeliveryStatus, or an AttemptResult (`sent` / `failed`). */
  status: string;
}

export function DeliveryStatusBadge({ status }: DeliveryStatusBadgeProps) {
  return (
    <Badge variant={statusBadgeVariant(status)}>
      {getLabel(DELIVERY_STATUS_LABELS, status)}
    </Badge>
  );
}
